var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.918 4.33331H4.33464C3.76 4.33331 3.2089 4.56159 2.80257 4.96792C2.39624 5.37425 2.16797 5.92535 2.16797 6.49998V21.6666C2.16797 22.2413 2.39624 22.7924 2.80257 23.1987C3.2089 23.605 3.76 23.8333 4.33464 23.8333H19.5013C20.0759 23.8333 20.627 23.605 21.0334 23.1987C21.4397 22.7924 21.668 22.2413 21.668 21.6666V14.0833M20.043 2.70831C20.4739 2.27734 21.0585 2.03522 21.668 2.03522C22.2775 2.03522 22.862 2.27734 23.293 2.70831C23.7239 3.13929 23.9661 3.72382 23.9661 4.33331C23.9661 4.94281 23.7239 5.52734 23.293 5.95831L13.0013 16.25L8.66797 17.3333L9.7513 13L20.043 2.70831Z",
    stroke: "#478F96",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1d5a03d6be8be4d200edcdb5f9f1bd9d.svg";
export { ForwardRef as ReactComponent };